import PaymentAcceptanceChoice from "../../dropshippingInterne/components/PaymentAcceptanceChoice";
import ProductShopSelector from "../../shops/ProductShopSelector";
import React, { useState, useEffect, useRef} from "react";
import { 

  MdDeleteForever, 
  MdEdit, 
  MdAdd, 
  MdOutlineDeleteForever, 
  MdImage,
  MdAddCircle,
  MdCategory,
  MdFilterList,
  MdNote,
  MdArrowDropDown,
  MdCompareArrows,
  MdLayers,
  MdSync,
} from "react-icons/md";
import {useParams} from "react-router-dom";
import { FiDelete, FiEdit3,  } from "react-icons/fi";
import { FaLongArrowAltLeft, FaCheck, FaSlidersH, FaChevronRight } from "react-icons/fa";
import Layout from "../../Layout/Layout";
import { centerTabInScroller } from "../../../utils/scrollTabIntoView";
import { getCategoriesByID, getCategoriesByName, getSubFilterBykeyFilter} from "../../auth/apiCategory";
import ProductStatusSwitch from "./ProductStatusSwitch";
import ReturnPolicyEditor from "../../pageInside/returnPolicy/ReturnPolicyEditor";
import { getUserProductPreview, deleteImageProduct, updateProduct, deleProductImageNote, linkCTP, UnlinkCTP, parcelProductUA, getImages, getCJCompare, syncProductImageUrls} from "../../auth/apiProduct";
import {getAddressById, isAuthenticated, getElakayLang} from "../../auth";
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { elakay_API } from "../../../config";
import AddProductNote from "../../pageInside/addProductNote"
import ImagesLoading from "../../pageInside/imagesLoading"
import LinkImagesTofilterPro from "../../pageInside/linkImagesTofilterPro";
import  AddFilterProduct from "../../pageInside/adfilterProduct"
import  CJVariantsSyncPanel from "../../pageInside/cjVariantsSyncPanel"
import { laguangeElakay } from "../../pageInside/dataElakay";
import AddParcel from "../../pageInside/AddParcel";
import ProductGridEdit from '../../pageInside/ProductGridEdit.jsx'
import ProdViewEdit from "../../pageInside/ProdViewEdit";
import {GrClose} from "react-icons/gr";
import CatSelected from "../categories/catSelected";
import CatSearch from "../categories/catSearch";
import Form from 'react-bootstrap/Form'
import {decryptData}  from '../../auth/elakayCryptage'
import "../category.css";
import "./EditProduct.css";
import "./ImageGalleries.css";
// Shared "Filters from your linked categories" pill styling (.provider-filters__value,
// .provider-filters__select-all, .provider-filters__check) -- same stylesheet
// Provider Edit Product uses, so both pages render identically, no duplicated CSS.
import "../../dropshippingInterne/provider/ProviderProductWizard.css";
import Modal from 'react-bootstrap/Modal'
import ErrorAlert from "../../pageInside/ErrorAlert";
import elakayEmptyBox from "../../Layout/icon/elakayEmptyBox.png";
import ShowimagesLoading from "../../pageInside/showImagesLoading";
import { getParamsAndQueriesCleaned } from "../../pageInside/ShowImage";
import UserPubGallery from "../../pageInside/Userpubgallery";
// Same "Filters from your linked categories" picker as Provider Edit Product
// (front_elakay/src/includes/dropshippingInterne/provider/ProviderFiltersEditor.jsx)
// -- shared component, single implementation, see FilterValuePicker.jsx.
// Seller-only "Filter combinations" grid (add + edit + remove in one place,
// replaces the old Add Filter/Edit Filter system -- see comment above
// combinationRows in this file).
import SellerProviderQuantityPanel from "./SellerProviderQuantityPanel";
import SellerFilterEditor from "./SellerFilterEditor";
import useSellerFilterEditor from "./useSellerFilterEditor";
import { sellerCategoryId } from "./useSellerCombinationRows";
import { isFinalSellerProductCategory } from "../categories/productCategoryRules";
import SellerDashboard from "../../pageInside/Graffiticonfiguratorartifact/SellerDashboard"
import ProductCompareEditor from "../../pageInside/ProductCompareEditor";
import ProductBundleManager from "../../pageInside/productBundles/ProductBundleManager";
import SyncStatusBadge from "../../pageInside/sync/SyncStatusBadge";
import "../../pageInside/sync/Synchronization.css";
import { getCurrentElakayRole } from "../../pageInside/Rolle";
import { elakayAutoText } from "../../pageInside/dataElakay";
import { listSellerProviderLinks, changeSellerPaymentAcceptanceMode } from "../../dropshippingInterne/services/providerProductService";
// Assistant de synchronisation CJ Dropshipping 3 étapes (Categories ->
// Shipping & Pricing -> Synchronization) -- le même modal que celui ouvert
// depuis les boutons Add/Sync des cards du catalogue CJ
// (dropShipping/CJDropshipping/components/ProductCollectionPage.js), mais
// nécessite son propre CJDropshippingProvider -- editProduct.jsx n'en a
// jamais eu besoin avant puisque l'ancien éditeur de sync (CJDropshippingSyncEditor)
// passait par les endpoints REST classiques d'apiProduct.js, pas par ce contexte.
// Import via le spécificateur de package "@elakay/cj-dropshipping" (résolu
// par le symlink node_modules/@elakay/cj-dropshipping -> dropShipping/CJDropshipping,
// déjà utilisé ailleurs dans src/, ex: CJDropshippingDashboard.jsx), PAS un
// chemin relatif direct : le ModuleScopePlugin de react-scripts bloque tout
// import relatif qui sort de src/, même vers un dossier du même repo bundlé
// par le même webpack.
import { CJDropshippingProvider, CJSyncModal, CJ_DROPSHIPPING_CSS } from "@elakay/cj-dropshipping";
import { useEditProductNavigation } from "./editProductNavigation";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["editProduct"]?.[key] || fallback;

// const imagesArray = [];

const filter =  new Object();
const filterGetSub =  new Object();

const checkGraphic = (data) => {
  if (!Array.isArray(data.filtersProduct)) return false;

  return data.filtersProduct.some(item => {
    const filter = item.filter;
    if (!filter || typeof filter !== "object") return false;

    // Parcourt toutes les clés/valeurs de filter
    for (const [key, valeur] of Object.entries(filter)) {
      if (typeof valeur === "string" && /graphic/i.test(valeur)) {
        return true;
      }
    }
    return false;
  });
}

const keySpaceCLean =(key) => {
  return  key?.toLowerCase()?.replace(/\s+/g, '').replace(/[^a-z0-9_]/g, '');
}

function createFilterObject(filt = {}) {
  Object.entries(filt).forEach(([key, value]) => {
    const cleanKey = keySpaceCLean(key); // conserve la casse d’origine
    const cleanValue = typeof value === "string" ? value.trim() : value;

    if (cleanValue !== "" && cleanValue !== null && cleanValue !== undefined) {
      filter[cleanKey] = cleanValue;
    }
  });
}


function getFilterKeysNonEmpty(obj) {
  if (!obj?.filter) return [];
  return Object.keys(obj.filter).filter(key => {
    const val = obj.filter[key];
    return val !== null && val !== "" && val !== undefined;
  });
}

function processFiltersAndLoadSub(filtersArray, filterObject, loadSubFilterBykeyFilter_, isKeyFilterIncluded) {
 
for (const key in filterGetSub) {
  delete filterGetSub[key];
}
  Object.entries(filterObject).forEach(([name, value]) => {

    // Trouver dans le tableau le filtre correspondant au nom (name)

    // if (obj) {
    filtersArray.forEach(obj => {
     
      // Vérifie si la valeur existe dans FilterItem ou dans subFilter
      const isSelected = isKeyFilterIncluded(obj._id.subFilter, value);

      if (isSelected) {
          // Exécute ta logique
        filterGetSub[name] = value;
       loadSubFilterBykeyFilter_(obj._id._id, value, keySpaceCLean(name),  filterObject);
      }

    })
    // }
  });
}


const etatProduit = {
  category: {
    fr: {
      texte: "Aucune catégorie n’est actuellement associée à ce produit.",
      question: "Souhaitez-vous en attribuer une afin d’optimiser son organisation et sa visibilité ?"
    },
    en: {
      texte: "No category is currently assigned to this product.",
      question: "Would you like to assign one to improve its organization and visibility?"
    },
    es: {
      texte: "Actualmente, este producto no tiene ninguna categoría asignada.",
      question: "¿Desea asignar una para optimizar su organización y visibilidad?"
    },
    ht: {
      texte: "Pwodui sa a pa gen okenn kategori asosye ak li pou kounye a.",
      question: "Èske ou ta renmen mete youn pou amelyore òganizasyon ak vizibilite li?"
    },
    pt: {
      texte: "Nenhuma categoria está atualmente associada a este produto.",
      question: "Deseja atribuir uma para otimizar sua organização e visibilidade?"
    }
  },
  filter: {
    fr: {
      texte: "Ce produit ne dispose pas encore de filtres spécifiques.",
      question: "Souhaitez-vous en définir pour faciliter la recherche et le tri ?"
    },
    en: {
      texte: "This product does not yet have specific filters.",
      question: "Would you like to define some to facilitate search and sorting?"
    },
    es: {
      texte: "Este producto aún no tiene filtros específicos.",
      question: "¿Desea definir algunos para facilitar la búsqueda y la clasificación?"
    },
    ht: {
      texte: "Pwodui sa a poko gen filtè espesifik.",
      question: "Èske ou ta renmen mete kèk filtè pou fasilite rechèch ak klasman?"
    },
    pt: {
      texte: "Este produto ainda não possui filtros específicos.",
      question: "Deseja definir alguns para facilitar a busca e a classificação?"
    }
  },
  image: {
    fr: {
      texte: "Aucune image n’est pour l’instant liée à ce produit.",
      question: "Souhaitez-vous en ajouter afin d’enrichir sa présentation visuelle ?"
    },
    en: {
      texte: "No image is currently linked to this product.",
      question: "Would you like to add one to enhance its visual presentation?"
    },
    es: {
      texte: "Actualmente, este producto no tiene ninguna imagen asociada.",
      question: "¿Desea agregar una para mejorar su presentación visual?"
    },
    ht: {
      texte: "Pwodui sa a pa gen okenn imaj asosye ak li pou kounye a.",
      question: "Èske ou ta renmen ajoute youn pou amelyore prezantasyon vizyèl li?"
    },
    pt: {
      texte: "Nenhuma imagem está atualmente vinculada a este produto.",
      question: "Deseja adicionar uma para melhorar sua apresentação visual?"
    }
  },
  combined: {
    fr: {
      texte: "Ce produit ne possède actuellement ni catégorie, ni filtre, ni image.",
      question: "Souhaitez-vous compléter ses informations pour améliorer son affichage et sa classification ?"
    },
    en: {
      texte: "This product currently has no category, filter, or image.",
      question: "Would you like to complete its information to improve its display and classification?"
    },
    es: {
      texte: "Actualmente, este producto no tiene categoría, filtro ni imagen.",
      question: "¿Desea completar la información para mejorar su visualización y clasificación?"
    },
    ht: {
      texte: "Pwodui sa a pa genyen kategori, filtè ni imaj pou kounye a.",
      question: "Èske ou ta renmen konplete enfòmasyon li pou amelyore afichaj ak klasman li?"
    },
    pt: {
      texte: "Este produto atualmente não possui categoria, filtro ou imagem.",
      question: "Deseja completar as informações para melhorar sua exibição e classificação?"
    }
  }
};

const COLORS = [
  "Gray",
  "DarkBlue",
  "DarkSlateGray",
  "DarkSlateBlue",
  "DarkGreen",
  "MidnightBlue",
  "DarkOliveGreen",
  "DarkRed",
  "DarkMagenta",
  "Indigo",
  "DarkViolet",
  "SaddleBrown",
  "Brown",
  "Maroon",
  "DarkOrchid",
  "SlateGray",
  "DarkCyan",
  "FireBrick",
  "DarkGoldenRod",
  "DimGray",
  "Chocolate",
  "DarkKhaki",
  "Olive",
  "CadetBlue",
  "RosyBrown",
  "IndianRed",
  "BlueViolet",
  "Peru",
  "MediumVioletRed",
  "Crimson",
  "BurlyWood",
  "Blue",
  "Tomato",
  "Coral",
  "DarkSalmon",
  "Orchid",
  "Salmon",
  "CornflowerBlue",
  "Tan",
  "Orange",
  "GoldenRod",
  "LightSlateGray",
  "LightSteelBlue",
  "DodgerBlue",
  "DeepSkyBlue",
  "DeepPink",
  "Chartreuse",
  "LightBlue",
  "PowderBlue",
  "PeachPuff",
  "Bisque",
  "LightPink",
  "LightGray",
  "Silver",
  "Gainsboro",
  "AntiqueWhite",
  "Beige",
  "BlanchedAlmond",
  "LemonChiffon",
  "Lavender",
  "MistyRose",
  "HoneyDew",
  "Cornsilk",
  "Azure",
  "Ivory",
  "FloralWhite",
  "GhostWhite",
  "White"
];

function getEtatProduitInfo(key, lang) {
  if (etatProduit[key] && etatProduit[key][lang]) {
    return {
      key: key,
      ...etatProduit[key][lang]
    };
  } else {
    return {
      key: key,
      texte: "Information non disponible.",
      question: "Langue ou clé invalide."
    };
  }
}


const getFiels = (a, b) => {
  // Si 'a' n'est pas un tableau ou est vide → retourne []
  if (!Array.isArray(a) || a?.length === 0) return [];

  // Si 'b' est vide, null ou undefined → retourne directement 'a'
  if (!b) return a;

  // Vérifie si la clé 'b' existe au moins dans un objet
  const hasKey = a.some(obj => Object.prototype.hasOwnProperty.call(obj, b));
  if (!hasKey) return a; // Si la clé n'existe pas → retourne 'a'

  // Sinon, collecte les valeurs uniques pour cette clé
  const c = [];
  for (let i = 0; i < a?.length; i++) {
    const value = a[i][b];
    if (!c.includes(value)) {
      c.push(value);
    }
  }

  return c;
};

/**
 * ELAKAY – ProductEditPage_.jsx
 *
 * Wraps two views toggled by two header buttons:
 *   [✏️ Edit Product Info]  [🎨 Elakay Seller Studio]
 *
 * "Edit Product Info"   → renders ProductInfoForm_ (existing form, unchanged)
 * "Elakay Seller Studio"→ renders SellerDashboard_ (slot manager + design studio)
 *
 * Drop-in replacement — receives the same props as the original ProductInfoForm_.
 * Import SellerDashboard_ from "./SellerDashboard_1" in your real project.
 */


/* ── Inline styles scoped to this component only ── */

const CSS = `
.pep-root { font-family: 'DM Sans', 'Trebuchet MS', sans-serif; }

/* ── Tab bar ── */
.pep-tabbar {
  display: flex;
  gap: 0;
  margin-bottom: 20px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0,115,153,0.14);
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(0,115,153,0.07);
}

.pep-tab {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 13px 20px;
  border: none;
  background: transparent;
  color: #5a7a8a;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 600;
  letter-spacing: 0.3px;
  cursor: pointer;
  transition: all 0.18s ease;
  border-right: 1px solid rgba(0,115,153,0.10);
  position: relative;
  overflow: hidden;
}

.pep-tab:last-child { border-right: none; }

.pep-tab::after {
  content: '';
  position: absolute;
  bottom: 0; left: 0; right: 0;
  height: 2px;
  background: #007399;
  transform: scaleX(0);
  transition: transform 0.18s ease;
}

.pep-tab:hover:not(.pep-tab--active) {
  color: #0d2d3d;
  background: #f4f8fc;
}

.pep-tab--active {
  color: #007399;
  background: rgba(0,115,153,0.10);
}

.pep-tab--active::after { transform: scaleX(1); }

.pep-tab--studio.pep-tab--active {
  color: #00a4d8;
  background: rgba(0,164,216,0.10);
}

.pep-tab--studio.pep-tab--active::after {
  background: #00a4d8;
}

.pep-tab-icon {
  font-size: 15px;
  flex-shrink: 0;
}

.pep-tab-badge {
  font-size: 9px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 20px;
  background: rgba(0,164,216,0.12);
  color: #00a4d8;
  border: 1px solid rgba(0,164,216,0.25);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* ── Slide animation ── */
.pep-view {
  animation: pepSlideIn 0.22s ease;
}

@keyframes pepSlideIn {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ── Studio iframe wrapper (full-height) ── */
.pep-studio-wrap {
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgba(0,164,216,0.20);
  box-shadow: 0 8px 32px rgba(0,115,153,0.15);
  background: #f2f6fd;
}
`;

/* ════════════════════════════════════════════════
   DEMO stubs — replace with your real components
   In your project:
     import SellerDashboard_ from "./SellerDashboard_1";
════════════════════════════════════════════════ */


const SellerDashboardDemo = ({addImageToProduct= ()=>{}}) => {
  const [step, setStep] = useState(1);
  return (
    <div style={{
      background: "#0c0f1a", borderRadius: 14, overflow: "hidden", minHeight: 500,
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "center", gap: 16, padding: 40,
      border: "1px solid rgba(0,180,216,0.15)"
    }}>

      {/* Titre */}
      <div style={{
        fontFamily: "'Bebas Neue',sans-serif", fontSize: 36, letterSpacing: 4,
        background: "linear-gradient(135deg,#c9a227,#e8c14e)",
        WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", backgroundClip: "text"
      }}>{__elakayText("t001", "ELAKAY SELLER STUDIO for Graffiti Customization")}</div>

      {/* Icône no image */}
      <div style={{
        width: 64, height: 64, borderRadius: 12,
        background: "rgba(0,180,216,0.08)", border: "1px solid rgba(0,180,216,0.2)",
        display: "flex", alignItems: "center", justifyContent: "center"
      }}>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
          stroke="#00b4d8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2"/>
          <circle cx="8.5" cy="8.5" r="1.5"/>
          <path d="M21 15l-5-5L5 21"/>
          <line x1="4" y1="4" x2="20" y2="20" stroke="#ef4444" strokeWidth="1.5"/>
        </svg>
      </div>

      {/* Message no image */}
      <div style={{ fontSize: 15, fontWeight: 700, color: "#eef0ff", letterSpacing: 0.3 }}>{__elakayText("t002", "No product image")}</div>
      <div style={{ fontSize: 12, color: "#7a8499", textAlign: "center", maxWidth: 340, lineHeight: 1.6 }}>{__elakayText("t003", "You must add product photos before configuring graffiti customization. Go to")}{" "}
        <code style={{ color: "#00b4d8", background: "rgba(0,180,216,0.1)", padding: "1px 5px", borderRadius: 4 }}>{__elakayText("t004", "Filters → Images → More images")}</code>
      </div>

      {/* Bouton addImageToProduct */}
      <div
        onClick={addImageToProduct}
        style={{
          marginTop: 4, padding: "10px 24px", borderRadius: 20,
          background: "rgba(0,180,216,0.15)", border: "1px solid #00b4d8",
          color: "#00b4d8", fontSize: 12, fontWeight: 700,
          cursor: "pointer", transition: "all .18s", letterSpacing: 0.3
        }}
      >{__elakayText("t005", "+ Add product images")}</div>


      <div style={{ fontSize: 11, color: "rgba(122,132,153,0.6)", marginTop: 4 }}>{__elakayText("t006", "↑ Step")}{step}{__elakayText("t007", "— add images to unlock the Design Studio")}</div>

    </div>
  );
};
// ========== PRODUCT INFO FORM ==========
 export  const ProductInfoForm = (props) => {
  const {
    infoSource ={},
    name,
    description,
    price,
    costPrice,
    words,
    inputValue,
    addressSelect,
    shopIds, setShopIds,
    address,
    values,
    graphic,
    creatorDesign,
    filtersProduct,
    getMaxkey,
    handleChange,
    handleKeyDown,
    setInputValue,
    setAddressSelect,
    setValues,
    deleteWord,
    addWord,
    clickSubmit,
    checkGraphic,
  } = props;

  const nameRef = useRef(null);
  const priceRef = useRef(null);
  const addressSelectRef = useRef(null);

  const handleSubmitClick = (e) => {
    const missing = [
      [name, nameRef],
      [price, priceRef],
      [addressSelect || shopIds?.length, addressSelectRef],
    ].find(([value]) => !value);
    if (missing) {
      e.preventDefault();
      missing[1].current?.scrollIntoView({ behavior: "smooth", block: "center" });
      missing[1].current?.focus?.();
      return;
    }
    clickSubmit(e);
  };
  __setElakayInfoSource(infoSource);

     return (<div className="content-card">
      <div className="card-header">
        <h3 className="card-title">
          {infoSource.language(infoSource, "title", "editProduct") || elakayAutoText("h_f8f4e0d8dd9408", "Edit Product")}
        </h3>
      </div>

      <form 
      className="product-form"
       onSubmit={(e) => e.preventDefault()}
       >
        {/* Name */}
        <div className="form-group-modern">
          <label className="form-label">
            {infoSource.language(infoSource, "sellPage", "name") || elakayAutoText("h_709a23220f2c3d", "Name")}
          </label>
          <input
            ref={nameRef}
            type="text"
            className="form-input"
            value={name ?? ""}
            onChange={handleChange("name")}
            onKeyDown={handleKeyDown}
            placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).editEditProduct.t001}
          />
          <span className="form-hint">{elakayAutoText("h_editproduct_hint_name", "The product name buyers will see in search and on the product page")}</span>
        </div>

        {/* Description */}
        <div className="form-group-modern">
          <label className="form-label">
            {infoSource.language(infoSource, "sellPage", "description") || elakayAutoText("h_55f8ebc805e65b", "Description")}
          </label>
          <textarea
            className="form-textarea"
            value={description ?? ""}
            onChange={handleChange("description")}
            onKeyDown={handleKeyDown}
            rows="4"
            placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).editEditProduct.t002}
          />
          <span className="form-hint">{elakayAutoText("h_editproduct_hint_description", "Describe the product: materials, size, what's included, and anything a buyer should know")}</span>
        </div>

        {/* Keywords */}
        <div className="form-group-modern">
          <label className="form-label">
            {infoSource.language?.(infoSource, "label", "keyWordsSearch") || elakayAutoText("h_615eb155f13f6d", "Keywords for Search")}
          </label>
          <div className="keywords-container">
            {words.map((word, index) => (
              <div key={index} className="keyword-tag">
                {word}
                <button
                  onClick={(e) => deleteWord(index, e)}
                  className="keyword-delete"
                  type="button"
                >
                  <MdDeleteForever />
                </button>
              </div>
            ))}
            {words.length < 9 && (
              <div className="keyword-input-group">
                <input
                  type="text"
                  placeholder={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).editEditProduct.t003}
                  value={inputValue ?? ""}
                  onChange={(e) => setInputValue(e.target.value)}
                  onKeyDown={handleKeyDown}
                  className="keyword-input"
                />
                <button onClick={addWord} className="keyword-add-btn" type="button">
                  <MdAddCircle />
                </button>
              </div>
            )}
          </div>
          {getMaxkey && <span className="form-error">{getMaxkey}</span>}
          <span className="form-hint">{__elakayText("t008", "Add up to 9 keywords to improve your product's visibility")}</span>
        </div>

        {/* Prices */}
        <div className="form-row">
          <div className="form-group-modern">
            <label className="form-label">
              {infoSource.language?.(infoSource, "label", "costPrice") || elakayAutoText("h_6028a9a64574b4", "Cost Price")}
            </label>
            <div className="input-with-prefix">
              <span className="input-prefix">$</span>
              <input
                type="number"
                className="form-input"
                value={costPrice ?? ""}
                onChange={handleChange("costPrice")}
                onKeyDown={handleKeyDown}
                placeholder="0.00"
                min="0"
              />
            </div>
            <span className="form-hint">{elakayAutoText("h_editproduct_hint_costprice", "What you paid to acquire or make this product (used to calculate your profit)")}</span>
          </div>

          <div className="form-group-modern">
            <label className="form-label">
              {infoSource.language(infoSource, "sellPage", "price") || elakayAutoText("h_3e8248e32edfca", "Price")}
            </label>
            <div className="input-with-prefix">
              <span className="input-prefix">$</span>
              <input
                ref={priceRef}
                type="number"
                className="form-input"
                value={price ?? ""}
                onChange={handleChange("price")}
                onKeyDown={handleKeyDown}
                placeholder="0.00"
                min="0"
              />
            </div>
            <span className="form-hint">{elakayAutoText("h_editproduct_hint_price", "The price buyers will pay for this product")}</span>
          </div>
        </div>

        <ProductShopSelector value={shopIds} onChange={setShopIds} />
        {/* Address */}
        <div className="form-group-modern">
          <label className="form-label">
            {infoSource.language(infoSource, "sellPage", "adressShop") || elakayAutoText("h_e41bed585407a2", "Shop Address")}
          </label>
          <select
            ref={addressSelectRef}
            className="form-select"
            value={addressSelect?._id || "0"}
            onChange={(e) => {
              const selectedAddr = address.find(a => a._id === e.target.value);
              setAddressSelect(selectedAddr);
            }}
          >
            <option value="0">
              {infoSource.language(infoSource, "label", "pleaseSelect") || elakayAutoText("h_1ddc4c9044f546", "Please Select")}
            </option>
            {address.map((addr, i) => (
              <option key={i} value={addr._id}>
                ({addr.firstName} {addr.lastName}) {addr.Address1}, {addr.city}
              </option>
            ))}
          </select>
          <span className="form-hint">{elakayAutoText("h_editproduct_hint_addressshop", "The address this product ships from")}</span>
        </div>

        {/* Shipping Toggle */}
        <div className="form-group-modern">
          <div className="toggle-group">
            <label className="toggle-label">
              {infoSource.language(infoSource, "sellPage", "freeShipping")   || elakayAutoText("h_f5da90c2a0cb7d", "Free Shipping")}
            </label>
            <label className="switch-modern">
              <input
                type="checkbox"
                checked={Boolean(values.shipping)}
                onChange={() =>
                  setValues({ ...values, shipping: !values.shipping })
                }
              />
              <span className="slider-modern"></span>
            </label>
          </div>
          <span className="form-hint">
            {infoSource.language(infoSource, "label", "onChargeShipping") || elakayAutoText("h_84c3ba1573f30a", "Enable free shipping for this product")}
          </span>
        </div>

        {!values.shipping && (
          <div className="form-group-modern">
            <label className="form-label">
              {elakayAutoText("h_editproduct_shippingprice_label", "Shipping price")}
            </label>
            <div className="input-with-prefix">
              <span className="input-prefix">$</span>
              <input
                type="number"
                className="form-input"
                value={values.shippingPrice ?? ""}
                onChange={handleChange("shippingPrice")}
                placeholder="0.00"
                min="0"
                step="0.01"
              />
            </div>
            <span className="form-hint">{elakayAutoText("h_editproduct_hint_shippingprice", "The amount buyers will be charged for shipping this product")}</span>
          </div>
        )}
        {
      checkGraphic({filtersProduct})   &&   <>
             <div  className="form-group-modern">
                <div className="toggle-group">
                    <label className="toggle-label">{infoSource.laguangeElakay('sellPage', infoSource.languageAPI).graphicDesign} </label><br/>
                        <label className="switch-modern">
                             <input 
                                onChange={() => setValues({ ...values, graphic: !graphic }) }
                                type="checkbox" 
                                checked={graphic ? 'checked' : ''}
                            />
                        <span className="slider-modern"></span>
                        </label>
                        </div>
                    <span className="form-hint text-info"> {infoSource.laguangeElakay('text',  infoSource.languageAPI).graphicAddProduct}</span>
                </div>

                    <div  className="form-group">
                      <div className="toggle-group">
                    <label className="toggle-label">{infoSource.laguangeElakay('sellPage', infoSource.languageAPI).creatorNoteDesign} </label><br/>
                        <label className="switch-modern">
                             <input 
                                onChange={() => setValues({ ...values, creatorDesign: !creatorDesign }) }
                                type="checkbox" 
                                checked={creatorDesign ? 'checked' : ''}
                            />
                        <span className="slider-modern"></span>
                        </label> </div>
                    <span className="form-hint text-info"> {infoSource.laguangeElakay('text',  infoSource.languageAPI).graphicAddCustomDesign}</span>
                </div>
                </>
}

        {/* Submit Button */}
        <div className="form-actions m-3">
          <button
            type="submit"
            className={`btn-primary-modern ${values.loading ? 'btn-loading' : ''}`}
            disabled={values.loading}
             onClick={handleSubmitClick}
          >
            {!values.loading && <FiEdit3 />}
            {values.loading ? elakayAutoText("h_e349e5c920d84f", "Updating...") : (infoSource.language(infoSource, "Button", "edit") || elakayAutoText("h_ab1b8e06500a3f", "Update Product"))}
          </button>
        </div>
      </form>
    </div>
  )};


/* ════════════════════════════════════════════════
   MAIN EXPORT — ProductEditPage_
   Props: same as your existing ProductInfoForm_
   + optionally: productId, checkGraphic, filtersProduct, etc.
════════════════════════════════════════════════ */
export function ProductEditPage(props) {
  const {
    infoSource = {},
    filtersProduct = [],
    graphicDesign = false
  } = props;
  /* "info" = Edit Product Info tab, "studio" = Elakay Seller Studio tab */
  const [activeTab, setActiveTab] = useState("info");

  /* In your real project, swap these with the real components:
     import { ProductInfoForm_ } from "./ProductInfoForm_";
     import SellerDashboard_    from "./SellerDashboard_1";
  */
  const InfoForm = props.ProductInfoForm ;
  const Studio   = props?.ImagesProd?.galeries?.length > 0 ? props.SellerDashboard :  props.SellerDashboardDemo 

  return (
   <>
      <style dangerouslySetInnerHTML={{ __html: CSS }} />
      <div className="pep-root">

        {/* ── Two-button tab bar ── */}
  {     graphicDesign &&  <div className="pep-tabbar">

          {/* Button 1 — Edit Product Info */}
          <button
            type="button"
            className={`pep-tab${activeTab === "info" ? " pep-tab--active" : ""}`}
            onClick={() => setActiveTab("info")}
          >
            <span className="pep-tab-icon">✏️</span>{__elakayText("t009", "Edit Product Info")}</button>

          {/* Button 2 — Elakay Seller Studio */}
          <button
            type="button"
            className={`pep-tab pep-tab--studio${activeTab === "studio" ? " pep-tab--active" : ""}`}
            onClick={() => setActiveTab("studio")}
          >
            <span className="pep-tab-icon">🎨</span>{__elakayText("t010", "Elakay Seller Studio for Graffiti Customization")}<span className="pep-tab-badge">{elakayAutoText("h_66aabd91fc41cc", "NEW")}</span>
          </button>

        </div>}

        {/* ── View: Edit Product Info ── */}
        {activeTab === "info"  && (
          <div className="pep-view">
            {/* Pass all props through to your real ProductInfoForm_ */}
            <InfoForm {...props} />
          </div>
        )}

        {/* ── View: Elakay Seller Studio ── */}
        {graphicDesign && activeTab === "studio" && (
          <div className="pep-view pep-studio-wrap">
            <Studio {...props} />
          </div>
        )}

      </div>
    </>
  );
}

/* ════════════════════════════════════════════════
   USAGE EXAMPLE (in your existing page):

   // Before:
   import ProductInfoForm_ from "./ProductInfoForm_";
   <ProductInfoForm_ ... />

   // After:
   import ProductEditPage_ from "./ProductEditPage_";
   import { ProductInfoForm_ } from "./ProductInfoForm_";
   import SellerDashboard_    from "./SellerDashboard_1";

   <ProductEditPage_
     // pass all existing ProductInfoForm_ props:
     infoSource={infoSource}
     name={name}
     description={description}
     price={price}
     ...etc
     // pass the real components:
     ProductInfoForm_={ProductInfoForm_}
     SellerDashboard_={SellerDashboard_}
   />
════════════════════════════════════════════════ */


const EditProduct = props => {
    const {
        infoSource
            } = props

    const {
        userInfo = [],
        address = []
        } = infoSource
    
    let emptParcel = {
        length: "",
        width: "",
        height: "",
        weight: ""
    }

    let emptFiltersHand = {
        catID:"",
        quantity:"",
        priceFil:"",
        filter:{},
        parcel:{}
        }

    const params = useParams();
    const productsID = params.productId;
    const {
      tab: editProductTab,
      section: editProductSection,
      view: editProductView,
      changeTab: changeEditProductTab,
      changeSection: changeEditProductSection,
      changeView: changeEditProductView,
    } = useEditProductNavigation();
    // Keep the legacy internal names used throughout this large component,
    // but derive them exclusively from the canonical URL.
    const activeTab = editProductTab === "filters-images"
      ? "filters"
      : (editProductTab === "note-product" ? "notes" : editProductTab);
    const activeSubTab = ({ filters: "combinations", display: "preview", images: "images" })[editProductSection] || "combinations";
    const setActiveTab = (tab) => changeEditProductTab(
      tab === "filters" ? "filters-images" : (tab === "notes" ? "note-product" : tab)
    );
    const setActiveSubTab = (section) => changeEditProductSection(({ combinations: "filters", preview: "display", images: "images" })[section] || "filters");
    const pageLAAI = ({
      "add-images": "moreImages",
      "link-filters": "linkImages",
      "publication-gallery": "pubImages",
    })[editProductView] || "moreImages";
    const setPageLAAI = (panel) => changeEditProductView(({
      moreImages: "add-images",
      linkImages: "link-filters",
      pubImages: "publication-gallery",
    })[panel] || "add-images");
    const navigationTabsRef = useRef(null);
     const [editInfoProd, setEditInfoProd] = useState(false);
     const [showProductStatusModal, setShowProductStatusModal] = useState(false);
     const [editInfo, setEditInfo] = useState({
      texte: "",
      question: ""
    });
    
    // Alimenté par le useEffect juste après la déclaration de getProduct
    // (getCJCompare, résolu au premier passage sur l'onglet Synchronization)
    // -- permet au header de cette section d'afficher un badge de statut et
    // une date de dernière synchro réelles. Déclaré ici (haut niveau du
    // composant, jamais dans SynchronizationSection) parce que cette
    // dernière n'est qu'une closure de rendu appelée depuis renderTabContent,
    // pas un vrai composant -- des hooks dedans y seraient appelés
    // conditionnellement (seulement quand activeTab==="sync"), ce qui
    // casserait les Rules of Hooks.
    const [syncStatusMeta, setSyncStatusMeta] = useState(null);
    // Id DropshippingProduct (catalogue CJ), distinct du Product._id Elakay
    // (productsID) -- requis par CJSyncModal (étape 2, devis de transport)
    // mais absent de getProduct (endpoint public preView/user, qui ne
    // renvoie jamais dropshippingData) : résolu via le même getCJCompare
    // authentifié que syncStatusMeta ci-dessus.
    const [syncDropshippingProductId, setSyncDropshippingProductId] = useState(null);
    const [syncResolveError, setSyncResolveError] = useState("");
    // Réponse complète de getCJCompare -- alimente CJVariantsSyncPanel (tab
    // Filters & Images > Display Settings) avec la liste réelle des variants
    // CJ (comparison.variants.cjValue / dropshippingData.variants), en plus
    // de syncStatusMeta/syncDropshippingProductId déjà dérivés ci-dessus.
    const [cjCompareData, setCjCompareData] = useState(null);

    const [words, setWords] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [getMaxkey, setMaxkey] = useState('');
    const [catSelectedSearch, setcatSelectedSearch] = useState(false);
    const [categoryID,  setCategoryID] = useState()
    const [search, setSearch] = useState([]);
    const [searchInput, setSearchInput] = useState('');
    const [shopIds, setShopIds] = useState(undefined);
    const [addressSelect, setAddressSelect] = useState('');
    const [shopAddress, setShopAddress] = useState('');
    const [filtersCategory, setFiltersCategory] = useState([])
    const [imagesArray, setImagesArray] = useState([])
    const [imagesSms, setImagesSMS] = useState("")
    const [filtersProduct, setFiltersProduct] = useState([])
    const [filterSel, setFilterSel] = useState([]);
    const [ImagesProd, setImagesProd] = useState([]);
    const item = ""
    const nameImg = item ? item : 'elakay image'
    const { token } = isAuthenticated()
    const [note, setNote] = useState([])
    const [selectCatalogId, setSelectCatalogId] = useState();
    const [items, setItems] = useState([]);
    const [itemFilValue, setItemFilValue] = useState({});
    const [getcategories, setCategories] = useState([])
    const [btnLinkCTP, setBtnLinkCTP] = useState(true)  
    const [getProduct, setProduct] = useState([])
    const [imageUrlsSyncing, setImageUrlsSyncing] = useState(false);
    const [imageUrlsSyncMessage, setImageUrlsSyncMessage] = useState("");
    const [paymentAcceptanceLink, setPaymentAcceptanceLink] = useState(null);
    const [paymentAcceptanceSaving, setPaymentAcceptanceSaving] = useState(false);
    const [paymentAcceptanceLoading, setPaymentAcceptanceLoading] = useState(false);
    const [paymentAcceptanceError, setPaymentAcceptanceError] = useState("");
    // getProduct vient de /products/preView/user (endpoint public "customer
    // preview"). Pour un produit dropshipping, ce endpoint reconstruit un
    // objet minimal (buildDropshippingCustomerProduct) qui NE contient PAS
    // dropshippingData -- seulement dropshippingPublic.platformName (voir
    // cjProductSyncService.js). platformSlug est donc lu en repli seulement,
    // pour le cas où ce comportement d'endpoint change un jour. Hoisté ici
    // (plutôt que recalculé dans NavigationTabs) pour être réutilisable par
    // le useEffect juste en dessous, sans dupliquer la même expression.
    const isCJDropshippingProduct = getProduct?.sourceType === "dropshipping" &&
      (getProduct?.dropshippingPublic?.platformName === "CJ Dropshipping" ||
        getProduct?.dropshippingData?.platformSlug === "cj");

    // Tout produit dropshipping/printify (pas seulement CJ) exige le mot de
    // passe Elakay pour toute modification -- requirePasswordForDropshippingProduct
    // l'impose déjà côté serveur pour /products/update et /products/deleteFilter,
    // ce flag sert seulement à faire apparaître la modale côté client plutôt
    // qu'un 428 brut non géré.
    const isDropshippingSourced = ["dropshipping", "printify"].includes(getProduct?.sourceType);
    // Provider-controlled availability (see providerSellerSync.js): quantity
    // for a provider_internal combination always follows the Provider's
    // current variant quantity via Resynchronize, so the grid shows it
    // read-only instead of letting the Seller set a value resync would
    // immediately overwrite.
    const isProviderInternalSourced = getProduct?.sourceType === "provider_internal";

    useEffect(() => {
      if (!isProviderInternalSourced || !productsID) { setPaymentAcceptanceLink(null); return; }
      let live = true;
      setPaymentAcceptanceLoading(true);
      setPaymentAcceptanceError("");
      listSellerProviderLinks(token).then((result) => {
        if (!live) return;
        if (result?.error) throw new Error(result.error);
        const ids = [productsID, getProduct?._id].filter(Boolean).map(String);
        const link = (result?.items || []).find((item) => ids.includes(String(item.sellerProductId?._id || item.sellerProductId)));
        if (!link) throw new Error(elakayAutoText("h_payment_link_load_error", "Unable to load payment acceptance settings. Refresh this page to retry."));
        setPaymentAcceptanceLink(link);
      }).catch((error) => { if (live) setPaymentAcceptanceError(error.message); })
        .finally(() => { if (live) setPaymentAcceptanceLoading(false); });
      return () => { live = false; };
    }, [isProviderInternalSourced, productsID, getProduct?._id, token]);

    const savePaymentAcceptanceMode = async (mode) => {
      if (!paymentAcceptanceLink || paymentAcceptanceSaving) return;
      setPaymentAcceptanceSaving(true);
      setPaymentAcceptanceError("");
      try {
        const result = await changeSellerPaymentAcceptanceMode(token, paymentAcceptanceLink._id, mode);
        if (result?.error) throw new Error(result.error);
        setPaymentAcceptanceLink((current) => ({ ...current, ...result.link, acceptanceMode: result.acceptanceMode || mode, paymentAcceptanceNeedsConfirmation: false,
          providerProductId: { ...current.providerProductId, dropshippingPayment: result.paymentAcceptance || current.providerProductId?.dropshippingPayment } }));
      } catch (error) { setPaymentAcceptanceError(error.message); }
      finally { setPaymentAcceptanceSaving(false); }
    };

    const currentFilterCategoryId = sellerCategoryId(getcategories?._id);
    const activeFilterCategoryId = selectCatalogId?.some(
      (entry) => sellerCategoryId(entry.catID) === currentFilterCategoryId
    ) ? currentFilterCategoryId : categoryID;
    const filterEditor = useSellerFilterEditor({
      productId: productsID,
      categoryId: currentFilterCategoryId,
      filtersCategory,
      filterProducts: filtersProduct,
      infoSource,
      token,
      requiresDropshippingConfirmation: isDropshippingSourced,
      onSaved: () => loadProductsView(productsID),
    });
    const { savingFilterCombinations } = filterEditor;

    // Résout dropshippingProductId + syncStatusMeta pour CJSyncModal/le
    // header de SynchronizationSection -- une seule fois par ouverture de
    // l'onglet Synchronization (pas à chaque frappe/changement ailleurs sur
    // la page), via le même endpoint authentifié que l'ancien
    // CJDropshippingSyncEditor (getCJCompare).
    // Extrait pour être ré-appelable après une action de CJVariantsSyncPanel
    // (add one / sync all / delete) -- ces actions changent product.filterProduct
    // côté serveur, mais loadProductsView (endpoint public preView/user) ne
    // reflète jamais filter.__cjVariantId (voir stripCustomerInternalDropshippingFields),
    // donc le panneau a besoin de son propre refresh via ce même endpoint
    // authentifié plutôt que de dépendre du remount de cet effet.
    const fetchCJCompareData = () => {
      if (!isCJDropshippingProduct || !productsID) return;
      setSyncResolveError("");
      getCJCompare(token, productsID).then((data) => {
        if (data?.error) {
          setSyncResolveError(data.error);
        } else {
          setSyncDropshippingProductId(data?.dropshippingData?.dropshippingProductId || null);
          setSyncStatusMeta({
            autoSync: data?.autoSync,
            lastSyncStatus: data?.dropshippingData?.lastSyncStatus,
            syncedAt: data?.dropshippingData?.syncedAt,
          });
          setCjCompareData(data);
        }
      });
    };

    useEffect(() => {
      // Chargé aussi sur "filters" : CJVariantsSyncPanel (Display Settings)
      // a besoin de la même liste de variants CJ que l'onglet Synchronization.
      if (activeTab !== "sync" && activeTab !== "filters") return;
      fetchCJCompareData();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, isCJDropshippingProduct, productsID]);

    // Liste des variants CJ vivants (catalogue fournisseur courant) pour
    // CJVariantsSyncPanel -- comparison.variants.cjValue plutôt que
    // dropshippingData.variants (cache) pour refléter ce qui est réellement
    // commandable chez CJ au moment où le seller ouvre cet onglet.
    const cjVariantsCompareRow = cjCompareData?.comparison?.find((row) => row.field === "variants");
    const cjVariants = cjVariantsCompareRow?.cjValue || cjCompareData?.dropshippingData?.variants || [];
    // cjCompareData.filterProduct (pas filtersProduct) : filtersProduct vient
    // de loadProductsView -> /products/preView/user, qui retire
    // filter.__cjVariantId/__cjSku/__cjImage (stripCustomerInternalDropshippingFields,
    // endpoint aussi utilisé pour la vue client publique) -- seul l'endpoint
    // authentifié getCJCompare renvoie encore ces tags.
    const syncedCJFilterProducts = (cjCompareData?.filterProduct || []).filter((entry) => entry?.filter?.__cjVariantId);

    const [parcel, setParcel] = useState(emptParcel)
    const [images, setImages] = useState("");
     const [imagesBackColor, setImagesBackColor] = useState("");
    const [FiltersHand, setFilterHand] = useState(emptFiltersHand)
      const [slots, setSlots] = useState([
    { id:"s0", label:elakayAutoText("h_dd19f9887573a9", "Front"), url:"", localUrl:"" },
  ]);
    // const [prodGaleries, setProdGaleries] = useState([]);
     const canvasRef = useRef(null);
    const [values, setValues] = useState({
        name: '',
        description: "",
        costPrice:"",
        price: "",
        shipping: false,
        shippingPrice: "",
        graphic: false,
        creatorDesign : false,
    });

        const {obj} = getElakayLang();
                const {code }= obj
    const {
        name,
        description,
        costPrice,
        price,
        shipping,
        shippingPrice,
        graphic,
        creatorDesign
    } = values;
    const createdFilter_ = (ArryFilter) => {

        for (let fil in filter){
        delete filter[fil]
        }
        ArryFilter.forEach(items => { 
            filter[keySpaceCLean(items._id.name)] = ""
            // filterArray.push(null)
        })
   
        setFilterHand({
            catID: getcategories._id,
            filter: filter,
            parcel:{},
            quantity:"",
            priceFil:""
            
        })
    }
/**
 * Met à jour `filter` pour qu’il corresponde aux clés dans `ArrayFilter`.
 * - Si une clé est nouvelle → on l’ajoute avec valeur vide "".
 * - Si une clé existait déjà et avait une valeur non vide → on la conserve.
 * - Si une clé était dans `filter` mais n’est plus dans `ArrayFilter` → on la supprime.
 *
 * @param {Array} ArrayFilter - tableau d’objets avec item._id.name
 * @param {Object} filter - objet à mettre à jour (modifié sur place)
 * @returns {Object} nouvel objet filtre (copie)
 */



const createdFilter = (ArrayFilter, fil = {}) => {
  // 🔸 Construire la liste des clés valides à partir de ArrayFilter

  const validKeys = ArrayFilter
    ?.map(item => keySpaceCLean(item._id?.name))
    .filter(Boolean);

  // 🔸 Supprimer les clés dans fil qui ne sont plus dans ArrayFilter
  Object.keys(fil).forEach(key => {
    if (!validKeys.includes(key)) {
      delete fil[key];
    }
  });

  // 🔸 Ajouter ou conserver les clés présentes dans ArrayFilter
  validKeys.forEach(key => {
    if (!fil.hasOwnProperty(key) || fil[key] === "") {
      fil[key] = ""; // crée ou remet à vide
    }
  });
  // 🔸 Retourne le nouvel objet
  return fil;
};


    const category = '5ed4946fd2ba8812c20261a8'
 
    const elakayCategoryID = params.categoryId ? params.categoryId : category;

    const loadCategory = async (categoryID, CF= false)=> {
          if (!categoryID) return;
           try {

                 const data  = await getCategoriesByID(categoryID);
    
                if (data.error || data == [] || data == undefined || data == null) {
                            throw new Error(data.error)
                            } else {
               setFiltersCategory(data.filter) 
                setCategories(data.cartegory)
                setItems(data.items)
                setSearch([])
                setInputValue('');
                CF && createdFilter_(data.filter)
                        }
                   } catch (err) {
            console.error("Erreur lors du chargement de l'utilisateur :", err);
          }
    };


  const loadCategory_ = async (categoryID, ObjectFil={})=> {
          if (!categoryID) return;
           try {

                 const data  = await getCategoriesByID(categoryID);
                if (data.error || data == [] || data == undefined || data == null) {
                            throw new Error(data.error)
                            } else {
               setFiltersCategory(data.filter) 
                setCategories(data.cartegory)
                setItems(data.items)
                setSearch([])
                setInputValue('');
                        }
                   } catch (err) {
            console.error("Erreur lors du chargement de l'utilisateur :", err);
          }
    };

    const loadProductsView = (productsID, a, loadCat = false)  => {
        
        productsID && getUserProductPreview(productsID ).then(data => {
            if (data.error) {
            } else {
              loadCat && loadCategory(data?.product?.categoriesID[0]?.catID?._id, true)
                loadImages(productsID, data)
                SelValfil(a, data.product.filters)
                setShopIds(data.product.boutiqueId?.length ? data.product.boutiqueId.map((s) => String(s?._id || s)) : undefined);
                setValues({
                        name: data.product.name ?? "",
                        description: data.product.description ?? "",
                        costPrice: data.product.costPrice ?? "",
                        price: data.product.price ?? "",
                        // The preview payload can omit these (a CJ product is
                        // rebuilt by the customer sanitizer without a root
                        // shippingPrice); undefined would turn the controlled
                        // inputs below into uncontrolled ones.
                        shipping: Boolean(data.product.shipping),
                        shippingPrice: data.product.shippingPrice ?? "",
                        graphic: Boolean(data.product.graphic),
                        creatorDesign: Boolean(data.product.creatorDesign)
                    })
                setWords(data.product.keysProduct? data.product.keysProduct : [])
                setParcel(data.filterProduct?.length > 0 ? data.filterProduct[0].parcel: emptParcel)
              setCategoryID(data.product.categoriesID?.length > 0 && data.product.categoriesID[0].catID._id)
                setAddressSelect(data.shopAddress)
                // setShopAddress(data.shopAddress)
                // setProdGaleries(data.galeries)
                
                setFiltersProduct(data.product.filterProduct)
                setFilterSel(data.product.filters)
                
                setSelectCatalogId(data.product.categoriesID)
                setNote(data.note)
                setProduct(data.product) 
                
            }
        });
    };

   // Définir les paramètres de la query string
 



// mini helpers (gèrent ancien/nouveau format)
const idOf   = (it) => String(it?._id?.['_id'] ?? it?._id);
const nameOf = (it) => it?._id?.name ?? it?.name;
const normalize = (it) =>
  it?._id && typeof it._id === 'object' && '_id' in it._id
    ? { ...it, Filters: Array.isArray(it.Filters) ? it.Filters : [] } // déjà ancien format
    : { _id: { ...it }, Filters: [] };                                // nouveau -> enveloppé

/**
 * Ajoute un batch après l’élément dont le name === afterName (ex: "color")
 * - évite les doublons par _id
 * - normalise tout en { _id:{...}, Filters:[] }
 */
const addBatchAfterName = (batch, afterName = "") => {
 setFiltersCategory(prev => {
    const cur = prev?.map(normalize);
    const curIds = new Set(cur?.map(idOf));

    const toInsert = batch?.map(normalize).filter(b => !curIds.has(idOf(b)));
    if (toInsert?.length === 0) return cur;

    const anchorIdx = cur.findIndex(it => nameOf(it) === afterName);
    if (anchorIdx === -1) return [...cur, ...toInsert];
let newArray =  [
      ...cur.slice(0, anchorIdx + 1),
      ...toInsert,
      ...cur.slice(anchorIdx + 1)
    ]
   
    createdFilter(newArray, filter);
    return newArray ;
  });
};

const addBatchAfterName_ = (batch, afterName = "", fil={}) => {
 setFiltersCategory(prev => {
    const cur = prev?.map(normalize);
    const curIds = new Set(cur?.map(idOf));

    const toInsert = batch?.map(normalize).filter(b => !curIds.has(idOf(b)));
    if (toInsert?.length === 0) return cur;

    const anchorIdx = cur.findIndex(it => nameOf(it) === afterName);
    if (anchorIdx === -1) return [...cur, ...toInsert];
let newArray =  [
      ...cur.slice(0, anchorIdx + 1),
      ...toInsert,
      ...cur.slice(anchorIdx + 1)
    ]
  
    // createdFilter(newArray, fil);
    return newArray ;
  });
};

/**
 * Supprime du tableau `prevFilters` tous les objets qui ont un _id présent dans `batch`.
 * Retourne { updated, removed }.
 */
const removeBatchFromFilters = (prevFilters, batch) => {
  const batchIds = new Set(batch?.map(idOf));
  const removed = [];
  const updated = [];

  for (const item of prevFilters) {
    const id = idOf(item);
    if (batchIds.has(id)) {
      removed.push(item); // trouvé dans batch → supprimé
    } else {
      updated.push(item); // sinon → conservé
    }
  }

createdFilter(updated, filter);
 setFiltersCategory(updated);
  return { updated, removed };
};

    const isKeyFilterIncluded= (subFilterArray, key) => {
  if (!Array.isArray(subFilterArray) || typeof key !== "string") return false;
  return subFilterArray.some(item => String(item.keyFilter) === String(keySpaceCLean(key)));
}


  const loadSubFilterBykeyFilter_ = async (filterID, keyFilter, name, fil) => {

                try {
                    await getSubFilterBykeyFilter(filterID, keyFilter).then(data => {
                if (data.error) {
                    throw new Error("data Not Found")
                 } else { 
              addBatchAfterName_(data, name, fil); 
                }
                })
               }catch(err) {
                    console.error("Erreur lors du chargement de l'utilisateur :", err);
                }
    };

   const loadSubFilterBykeyFilter = async (filterID, keyFilter, name) => {

                try {
                    await getSubFilterBykeyFilter(filterID, keyFilter).then(data => {
                if (data.error) {
                    throw new Error("data Not Found")
                 } else { 
              addBatchAfterName(data, name); 
                }
                })
               }catch(err) {
                    console.error("Erreur lors du chargement de l'utilisateur :", err);
                }
    };
  

    const removeSubFilterBykeyFilter = async (filterID, keyFilter) => {
         try {
                    await getSubFilterBykeyFilter(filterID, keyFilter).then(data => {
                if (data.error) {
                    throw new Error("data Not Found")
                 } else {
                 removeBatchFromFilters(filtersCategory, data); 
                }
                })
               }catch(err) {
                    console.error("Erreur lors du chargement de l'utilisateur :", err);
                }
    };

    const productTrue = name !== "" && price !== "" && description !== ""   && addressSelect !== undefined  && words?.length >= 0
    const bntLinkImgtoFil = (b)=>{
       
        let t =  imagesArray.includes(b) 

        let c 
       if(pageLAAI === "linkImages"){
        if(!t){ 
        if(imagesArray?.length === 4 ){
            setImagesSMS("you can only add 4 images")
        }else{
            setImagesSMS("")
        c = [...imagesArray, b]
            setImagesArray(c)
            }
        }else{
            setImagesSMS("")
           setImagesArray(imagesArray.filter(item => item !== b));
        }
    }

        if(pageLAAI ===  "pubImages"){
              setImages(images === b ?"":b)
            // handleUrlSubmit(b)
          
    }

    }

    const addressId = (token, adressId) => {

        adressId && (
            getAddressById(token, adressId).then(data => {
                if (!data || data.error) {
                    setAddressSelect('')
                } else {
                    setAddressSelect(data[0])
                }
            }))
    }


    const loadImages =(Id, doc)=> {
        getImages(Id).then(data => {
            if (!data || data.error) {
            } else {
              checkingInfoMissing(doc.product.filterProduct, doc.product.categoriesID, data.galeries) 
              setImagesProd(data)
            }
        });
    };



    const deleteImage = (token, Id, imageID, a) => {
        deleteImageProduct(token, Id, imageID).then(data => {
            if (data.error) {
            } else {
                loadProductsView(Id)
                imagesFilters(a)
            }
        });
    };

    const deleteImageNote = (token, Id, imageID) => {
        deleProductImageNote(token, Id, imageID).then(data => {
            if (data.error) {
            } else {
                
                loadProductsView(Id)

            }
        });
    };


    const SelValfil =(a, b)=>{
      
        b && b.filter(Item => {
          if (Item._id._id === a){
            setItemFilValue(Item)
          }
        })
    }

const checkingInfo =(a=[], key)=>{
if(a?.length == 0){
let data = getEtatProduitInfo(key, code)
setEditInfoProd(true)
setEditInfo(data)
} 
}


const checkingInfoMissing =(f=[], c=[], i=[])=>{
if(c?.length == 0){
let data = getEtatProduitInfo('category', code)
setEditInfoProd(true)
setEditInfo(data)
} else if(f?.length == 0){
let data = getEtatProduitInfo('filter', code)
setEditInfoProd(true)
setEditInfo(data)
} else if(i?.length == 0){
let data = getEtatProduitInfo('image', code)
setEditInfoProd(true)
setEditInfo(data)
}
}



    useEffect(() => {
      loadProductsView(productsID);
      // Product data is tied to the route id, not to navigation queries.
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productsID, token]);

    useEffect(() => {
      if (activeTab === "filters" && activeFilterCategoryId) loadCategory(activeFilterCategoryId, true);
      // A direct filters-images URL loads category metadata after the product.
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab, activeFilterCategoryId]);

    useEffect(() => {
      if (activeTab === "categories") loadCategory(category);
      // Preserve the category browser's existing root load on direct URLs.
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab]);

    useEffect(() => {
      const container = navigationTabsRef.current;
      // Scrolls the tab strip only -- scrollIntoView also scrolled the page
      // sideways and revealed the off-canvas Filter drawer.
      centerTabInScroller(container, container?.querySelector(".nav-tab-btn.active"));
    }, [editProductTab]);



    const clickBack = (LA) => {
        loadCategory(LA)
    }

    const seleteCategory = () => event => {
       event.preventDefault();
        const supcategory =  event.target.value;
        loadCategory(supcategory)
        // setSelectCatalogId(supcategory)
    }

    const SelFilterCat = (_id = null, sh = true)=> async (event) =>{

     event.preventDefault();
        const ID = _id ? _id : event.target.value;
           try {
                      const encryptedData = await getCategoriesByID(ID);
                      const data = encryptedData;
                         if (data.error) {
                            throw new Error(data.error)
                            } else {
                    setCategories(data.cartegory)
                    setFiltersCategory(data.filter)
                    setItems(data.items)
                   sh && createdFilter_(data.filter)
                        }
                   } catch (err) {
            console.error("Erreur lors du chargement de l'utilisateur :", err);
          }
    }

    const ButtonBackCategory = () => {

        let CategoryIDSEl = getcategories.categoryID && getcategories.categoryID?.length > 1 ? getcategories.categoryID[1] : category

        return (
            <span onClick={() => clickBack(CategoryIDSEl)} className="h5 float-left">
                <FaLongArrowAltLeft />
            </span>
        )
    }
    const parcelChange = name => event => {
        const value = event.target.value;
        setParcel({ ...parcel, [name]: value });
    };

    const selectAdress = () => event => {
        const IdAdress = event.target.value;
        addressId(token, IdAdress)
    }
    
    const handleChange = name => event => {
       event.preventDefault();
       event.stopPropagation();
        const value = event.target.value;
        setValues({ ...values, error: false, [name]: value });
    };

    const clickSubmit = event => {
       event.preventDefault();
         if (words?.length >= 0 && words?.length < 3) return setMaxkey(setMaxInputValue(code, 'minKeywords'));

        setValues({ ...values, error: "", loading: true });

        // costPrice is server-blocked for dropshipping/printify products
        // (elakay_controllers/product/product.js DROPSHIPPING_BLOCKED_ROOT_FIELDS
        // -- real cost stays CJ-sync-controlled, never a manual edit) --
        // sending it at all, even unchanged, makes this whole PATCH 400
        // ("Invalid updates!") for every field, not just costPrice.
        // addressSelect is null when the product's boutique has no address
        // (handleSubmitClick lets a boutique stand in for the address); the
        // undefined addressShop is dropped by JSON.stringify, so the stored
        // one is kept.
        const productUpdate = {
            ...(shopIds === undefined ? {} : { boutiqueId: shopIds }),
            email: userInfo.email, name, description, price, shipping,
            shippingPrice: shipping ? 0 : (Number(shippingPrice) || 0),
            graphic, creatorDesign, addressShop: addressSelect?._id, keysProduct: words,
            ...(isDropshippingSourced ? {} : { costPrice }),
            ...(isDropshippingSourced ? { dropshippingPasswordRequired: true } : {}),
        };

        updateProduct(token, productsID, productUpdate).then(data => {
            if (data.error) {
                setValues({ ...values, error: data.error });
            } else {
             
                setValues({
                    ...values,
                    inpProduct: false,
                    filterProduct: true,
                    productID: data.productID,
                    createdProduct: data.name,
                    // redirectToFilter: true
                    loading: false,
                });
                loadProductsView(productsID)
              
            }
        });
    };


    const clickSubCat = () => {

        setValues({ ...values, error: "", loading: true });
        let infoCat =  {
            catID: getcategories._id, 
            // name: getcategories.name, 
            gategoriesLink: getcategories.categoryID
        }

        linkCTP(token, productsID, infoCat).then(data => {
            if (data.error) {
                setValues({ ...values, error: data.error });
            } else {
                loadCategory(category)
                setValues({
                    ...values,
                    inpProduct: false,
                    filterProduct: true,
                    productID: data.productID,
                    createdProduct: data.name,
                    // redirectToFilter: true
                    loading: false,
                });
                setSearchInput('')
                setSearch([])
                loadProductsView(productsID)
              
            }
        });
    };

    const clickParcel = event => {
        event.preventDefault();
        setValues({ ...values, error: "", loading: true });
        parcelProductUA(token, productsID, FiltersHand._id, parcel).then(data => {
            if (data.error) {
                setValues({ ...values, error: data.error });
            } else {
                setValues({
                    ...values,

                    inpProduct: false,
                    filterProduct: false,
                    imgPreview: true,
                    productID: data.productID,
                    // redirectToFilter: true
                    loading: false,
                });
                loadProductsView(productsID)
            }
        });
    };
    const dltLinkCTP= (a) => {
       
        setValues({ ...values, error: "", loading: true });
        UnlinkCTP(token, productsID, a).then(data => {
            if (data.error) {
                setValues({ ...values, error: data.error });
            } else {
                setValues({ ...values, error: "", loading: true });
                loadProductsView(productsID)
            }
        });
    };


  const NavigationTabs = () => {
   // isCJDropshippingProduct est hoisté au niveau du composant (juste après
   // getProduct) pour être partagé avec le useEffect de résolution du
   // Synchronization tab -- pas recalculé ici.
   const tabs = [
      { id: "info", label: infoSource.language(infoSource, "title", "info")  || "Info", icon: <MdEdit /> },
      { id: "categories", label: infoSource.language(infoSource, "title", "Categories") || "Categories", icon: <MdCategory /> },
      { id: "filters", label: infoSource.language(infoSource, "title", "filtersImgs") || "Filters & Images", icon: <MdFilterList /> },
      { id: "notes", label: infoSource.language(infoSource, "title", "noteProduct") || "Notes", icon: <MdNote /> },
      { id: "bundles", label: elakayAutoText("h_bnd_tab", "Product Bundles"), icon: <MdLayers /> },
      { id: "compare", label: elakayAutoText("h_8d105cf44d3926", "Compare"), icon: <MdCompareArrows /> },
      ...(isCJDropshippingProduct ? [{ id: "sync", label: elakayAutoText("h_sync_tab", "Synchronization"), icon: <MdSync /> }] : []),
    ];

    const handleImageUrlsSync = async () => {
      if (imageUrlsSyncing) return;
      setImageUrlsSyncing(true);
      setImageUrlsSyncMessage("");
      const result = await syncProductImageUrls(token, productsID);
      if (result?.success) {
        setProduct((current) => ({ ...current, ProductImageUrls: result.ProductImageUrls || [] }));
        setImageUrlsSyncMessage(`${result.count || 0} image URL(s) updated`);
      } else {
        setImageUrlsSyncMessage(result?.error || "Image URL update failed");
      }
      setImageUrlsSyncing(false);
    };

    return (
      <div className="product-edit-navigation">
       <div className="nav-tabs-modern" ref={navigationTabsRef}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`nav-tab-btn ${activeTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveTab(tab.id)}
          >
            <span className="nav-tab-icon">{tab.icon}</span>
            <span className="nav-tab-label">{tab.label}</span>
          </button>
        ))}
       </div>
       <button
         type="button"
         className="product-image-urls-sync-btn"
         onClick={handleImageUrlsSync}
         disabled={imageUrlsSyncing}
         title={elakayAutoText("h_44406724c746fd", "Update ProductImageUrls from galleries and Filters > Images")}
         aria-label={elakayAutoText("h_91814a37d9ab9b", "Update product image URLs")}
       >
         <MdSync className={imageUrlsSyncing ? "is-spinning" : ""} />
         <span>{imageUrlsSyncing ? elakayAutoText("h_4cc70d192390e9", "Updating images...") : elakayAutoText("h_68d8771dd6adb8", "Update image URLs")}</span>
       </button>
       {imageUrlsSyncMessage && (
         <span className="product-image-urls-sync-message" role="status">{imageUrlsSyncMessage}</span>
       )}
      </div>
    );
  };


        // selcet categorie pour les vendre 
        let listeCatSelSea = ['by selection', 'by name search']

        const handleCatSelSea = (a)=>{
        loadCategory(category)
            if(a == 'by selection'){
                setcatSelectedSearch(true)
            }else if (a == 'by name search'){
                setcatSelectedSearch(false)
            }
        }
        
        const checkedSelSea = (a)=>{
            if(a){
            return 'by selection'
            }else{
            return 'by name search'
            }
        }

        const CheckingCat = ()=>{
            return <div className="form-group">
         {/* <span  className="btn p-2"  onClick={() => clickButton2()}><GrClose/></span> */}
        <h2>{catSelectedSearch && ButtonBackCategory()} elakay {infoSource.language(infoSource, "title", "Categories")}</h2>
            { listeCatSelSea?.map((ob) =>{
        return <React.Fragment key={ob}> <input
                        className="form-check-input"
                        onChange={()=>handleCatSelSea(ob)}
                        checked={checkedSelSea(catSelectedSearch) === ob}
                        type="radio"
                        name="typeList"
                        id={"typeList_" + ob}
                        />
                <label className="form-check-label" htmlFor={"typeList_" + ob}>{ob}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>
            </React.Fragment>
        })}
        </div>
        
        }

        const selectCategory = () => {

            return<>
               {CheckingCat()}
              { catSelectedSearch ? <CatSelected
            //    clickButton2={clickButton2}
               ButtonBackCategory={ButtonBackCategory}
               clickBack={clickBack}
               seleteCategory={seleteCategory}
               laguangeElakay={laguangeElakay}
               infoSource={infoSource}
               categories={getcategories}
                /> : <CatSearch 
                infoSource={infoSource}
                search ={search}
                setSearch ={setSearch}
                setSearchInput={setSearchInput}
                searchInput={searchInput}
                getCategoriesByName={getCategoriesByName}
                categories={getcategories}
                loadCategory={loadCategory}
                />}
                </>
           }

          // ========== CATEGORIES SECTION ==========
          const CategoriesSection = () => (
            <div className="content-card">
              <div className="card-header">
                <h3 className="card-title">
                  {infoSource.language?.(infoSource, "title", "Categories") || elakayAutoText("h_039c03df15be4e", "Product Categories")}
                </h3>
              </div>
        
              <div className="card-content">
                {/* Selected Categories */}
                {selectCatalogId && selectCatalogId.length > 0 && (
                  <div className="selected-categories">
                    <h4 className="section-subtitle">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).editEditProduct.t004}</h4>
                    <div className="categories-list">
                      {selectCatalogId.map((cat, i) => (
                        <div key={i} className="category-item">
                          <div className="category-name">
                            {cat.catID?.name?.join(" > ") || elakayAutoText("h_a3c686e711e472", "Category")}
                          </div>
                          {/* cat.catID peut être null si la catégorie liée a été
                              supprimée côté serveur depuis (référence orpheline) --
                              rien à identifier pour l'unlink dans ce cas, bouton masqué
                              plutôt que crasher au clic sur cat.catID._id. */}
                          {cat.catID?._id ? (
                            <button
                              className="category-delete-btn"
                              onClick={() => dltLinkCTP(cat.catID._id)}
                            >
                              <MdOutlineDeleteForever />
                            </button>
                          ) : null}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
        
                {/* Category Selection */}
                <div className="category-selection">
                  <h4 className="section-subtitle">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).editEditProduct.t005}</h4>
                   {selectCategory()}
                 
                  <button 
                    className="btn-primary-modern mt-4"
                    onClick={clickSubCat}
                    disabled={!isFinalSellerProductCategory(getcategories, items, filtersCategory)}
                  >
                    <MdAdd />{__elakayText("t011", "Link Category")}</button>
                </div>
              </div>
            </div>
          );

          const deleteWord = (indexToDelete, e) => {
            e.preventDefault();
     if (e.key === undefined) {
    setWords(words.filter((_, i) => i !== indexToDelete));
     }
  };
const setMaxInputValue = (lang, type = 'minLength') => {
  const messages = {
    minLength: {
      fr: "Vous devez entrer plus de 3 caractères pour ajouter dans le keyword.",
      en: "You must enter more than 3 characters to add to the keyword.",
      ht: "Ou dwe antre plis pase 3 karaktè pou ajoute nan mo kle a.",
      pt: "Você deve digitar mais de 3 caracteres para adicionar à palavra-chave.",
      es: "Debe ingresar más de 3 caracteres para agregar a la palabra clave.",
    },
    minKeywords: {
      fr: "Vous devez ajouter un minimum de 3 mots-clés pour la recherche.",
      en: "You must add at least 3 keywords for searching.",
      ht: "Ou dwe ajoute omwen 3 mo kle pou rechèch la.",
      pt: "Você deve adicionar no mínimo 3 palavras-chave para a pesquisa.",
      es: "Debe agregar al menos 3 palabras clave para la búsqueda.",
    },
    maxKeywords: {
      fr: "Vous pouvez ajouter jusqu'à 9 mots-clés afin d’optimiser la visibilité de votre produit auprès des clients.",
      en: "You can add up to 9 keywords to improve your product’s visibility to customers.",
      ht: "Ou ka ajoute jiska 9 mo kle pou ogmante vizibilite pwodwi ou devan kliyan yo.",
      pt: "Você pode adicionar até 9 palavras-chave para aumentar a visibilidade do seu produto para os clientes.",
      es: "Puede añadir hasta 9 palabras clave para mejorar la visibilidad de su producto ante los clientes.",
    },
  };

  return (messages[type] && messages[type][lang]) || messages[type]?.en || "";
};

  const addWord = (e) => {
    e.preventDefault();
    if(inputValue?.length <= 3 && inputValue.trim() !== '') return setMaxkey(setMaxInputValue(code, 'minLength'));
    if (words?.length < 9 && inputValue?.length > 3) {
      setWords([...words, inputValue.trim()]);
      setInputValue('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
if(inputValue.trim() !== '' && words?.length < 9) return addWord(e);

    if(productTrue  &&  inputValue.trim() === ''){
         clickSubmit(e);
    }
    }
  };


const selFilterCatEnhanced = () => (
  selectCatalogId && selectCatalogId?.length > 0 && (
    <div className="category-selector-modern">
      <div className="category-selector-wrapper">
        <div className="category-selector-header">
          <MdCategory className="category-icon" />
          <label className="category-selector-label">
            {infoSource.language(infoSource, "label", "categoryFilter") || elakayAutoText("h_ac7a76eab7a151", "Filter by Category")}
          </label>
        </div>
        
        <div className="select-wrapper">
          <select 
            onChange={SelFilterCat()} 
            className="category-select"
            value={currentFilterCategoryId}
            disabled={savingFilterCombinations}
          >
            <option value="" disabled>
              {infoSource.laguangeElakay('label', infoSource.languageAPI).selectProdSell}
            </option>
            
            {selectCatalogId?.filter((c) => c.catID?._id).map((c, i) => (
              <option key={i} value={c.catID._id}>
                {(infoSource.getCategoryNames(c.catID, true).name || []).slice(0, -1).join(' › ')}
              </option>
            ))}
          </select>
          <MdArrowDropDown className="select-arrow" />
        </div>
        
        <span className="category-count">
          {selectCatalogId?.length}{elakayAutoText("h_7b231a50a498ef", "available")}</span>
      </div>
    </div>
  )
);

 
 const NbrProdImgMax = filtersProduct && getFiels(getFiels(filtersProduct, "filter"), "color")?.length * 4 + 4
const NrbProdImg = ImagesProd.galeries ? ImagesProd.galeries?.length : 0



    const imagesFilters = (a)=>(
    a &&  a?.length > 0 ?   <div className="col">
        <h4>
            {/* images filter Selected */}
            {infoSource.language(infoSource, "title", "imgfilSelc")}
            </h4>
    <Row xs={3} sm={4} md={5} lg={6} xl={6}>
        {a && a?.map((nm, i) => (
           <Col key={i}>
            <div className="m-2" style={{ position: "relative", overflow: "hidden", transition: "0.3s", width: "100%" }}>
                <ShowimagesLoading
                    src={`${elakay_API}/${nm}`}
                    alt={nm}
                    style={{ maxHeight: "50%", maxWidth: "50%" }}
                />
            </div>
        </Col>
        ))
        }
            
    </Row>
    </div>
:  a && <h4>
    {/* Not Image */}
    {infoSource.language(infoSource, "title", "notImage")}
    </h4>

    )

    const imagesSeletCSS =(a , b)=>{
       

        let x = {
            border: "1px solid lightgrey",
        }
        let y = {
            border: "3px solid #DAA520",
        }

          if (pageLAAI === "pubImages"){
            return b === images ? y : x
           
        }
         if (pageLAAI === "linkImages"){ 
           let e = a && a.includes(b)
            return e ? y : x
        }
       
    }


       const formImages = (a) =>(
<div className="form-images-modern">
      <div className="gallery-container-modern">
        <h4 className="gallery-title-modern">
          {infoSource.language(infoSource, "title", "allimgItem")}
        </h4>

        <Row xs={3} md={5}>
          {ImagesProd.galeries && ImagesProd.galeries?.map((nm, i) => (
            <Col key={i}>
              <div className="gallery-item-modern">
                <div
                  className="gallery-image-wrapper-modern"
                  style={imagesSeletCSS(a, nm.urlImg)}
                  onClick={() => bntLinkImgtoFil(nm.urlImg)}
                >
                  <ShowimagesLoading
                    src={nm.urlImg}
                    alt={nm._id || nm.urlImg}
                    style={{ maxHeight: "100%", maxWidth: "100%" }}
                  />
                  {/* Provider-referenced images (Dropshipping In) are readOnly: no _id, controlled by the Provider */}
                  {!nm.readOnly && nm._id && (
                    <div className="gallery-delete-overlay-modern">
                      <MdDeleteForever
                        onClick={(e) => {
                          e.stopPropagation();
                          deleteImage(token, productsID, nm._id, a);
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {imagesSms && (
          <p className="success-message-modern">{imagesSms}</p>
        )}
      </div>
    </div>
        )

   const imagesSeletCSS12 =(a)=>{
       
        let x = {
            border: "1px solid lightgrey"
        }
        let y = {
            border: "5px double #DAA520",
        }
      
       return a === imagesBackColor ? y : x
       
    }


    const submitBackGroundColor =(token)=>{

let urlImages =  getParamsAndQueriesCleaned (images)
const {param1, param2} = urlImages.params

            return fetch(`${elakay_API}/img/addBackGroundColor/${param1}/${param2}`, {
                    method: "PUT",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({bgc: imagesBackColor})
                })
                    .then(response => {
                        setImages("")
                        setImagesBackColor("")
                        return response.json();
                    })
                    .catch(err => {
                         console.error("Erreur lors du chargement :", err);
                return {
                  success: false,
                  error: err.message || "Une erreur inconnue est survenue"
                };
                    });

    }
    

    const allColor = (a) =>(
        
           <div className="all-colors-modern">
      <div className="colors-container-modern">
        <h4 className="colors-title-modern">
          {infoSource.language(infoSource, "title", "allimgItem")}
        </h4>

        {/* Preview with Selected Color */}
        {images ? (
          <div className="color-preview-section-modern">
            <div className="preview-image-wrapper-modern">
              <ShowimagesLoading
                className="preview-image-modern"
                src={images}
                alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).editEditProduct.t007}
                style={{
                  height: "100%",
                  width: "100%",
                  backgroundColor: imagesBackColor
                }}
              />

              <div className="preview-actions-modern">
                {imagesBackColor && images ? (
                  <button
                    onClick={() => submitBackGroundColor(token)}
                    className="btn-submit-color-modern primary"
                  >{elakayAutoText("h_2dacf659598498", "Submit")}</button>
                ) : (
                  <button
                    className="btn-submit-color-modern disabled"
                    disabled
                  >{elakayAutoText("h_2dacf659598498", "Submit")}</button>
                )}
              </div>
            </div>
          </div>
        ) : (
          <h1 className="no-image-warning-modern">{__elakayText("t012", "No image selected")}</h1>
        )}

        {/* Color Grid */}
        <Row xs={4} sm={6} md={8} lg={10} xl={12}>
          {COLORS?.map((nm, i) => (
            <Col key={i}>
              <div className="color-item-modern">
                <div
                  className="color-swatch-modern"
                  style={imagesSeletCSS12(nm)}
                  onClick={() => setImagesBackColor(imagesBackColor === nm ? "" : nm)}
                >
                  <img
                    className="color-swatch-image-modern"
                    src={elakayEmptyBox}
                    alt={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).editEditProduct.t008}
                    style={{
                      height: "100%",
                      width: "100%",
                      backgroundColor: nm
                    }}
                    onError={(event) => {
                      event.target.style.display = "none";
                    }}
                  />
                </div>
                <div className="color-label-modern">
                  {nm}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
        )
    

      
const NotesSection = () => (
  <div className="content-card">
    <div className="card-header">
      <h3 className="card-title">
        {infoSource?.language(infoSource, "title", "editNoteProduct") || elakayAutoText("h_ee586c6fe17986", "Product Notes")}
      </h3>
    </div>
    
    <div className="card-content">
      {/* ========== ADD NOTE FORM ========== */}
      <div className="note-form">
        <h4 className="section-subtitle">
          {infoSource?.language(infoSource, "label", "addNewNote") || elakayAutoText("h_33166f8c0788c9", "Add New Note")}
        </h4>
        
        {/* Use AddProductNote component */}
        <AddProductNote
          laguangeElakay={laguangeElakay}
          infoSource={infoSource}
          loadProductsView={loadProductsView}
          productIDEdit={productsID}
          token={token}
        />
      </div>

      {/* ========== EXISTING NOTES LIST ========== */}
      {note && note.length > 0 && (
        <div className="notes-list">
          <h4 className="section-subtitle">
            {infoSource?.language(infoSource, "label", "existingNotes") || elakayAutoText("h_e979ed924eec9c", "Existing Notes")}
          </h4>
          
          {note.map((n, i) => (
            <div key={i} className="note-card">
              {n.tilte && (
                <>
                  {/* Note Header with Delete */}
                  <div className="note-header">
                    <h5 className="note-title">{n.tilte}</h5>
                    <button
                      className="note-delete-btn"
                      onClick={() => deleteImageNote(token, productsID, n._id)}
                      aria-label={elakayAutoText("h_d626a79d3a6506", "Delete note {value0}", { value0: n.title })}
                    >
                      <MdDeleteForever />
                    </button>
                  </div>
                  
                  {/* Note Description */}
                  {n.description && (
                    <p className="note-description">{n.description}</p>
                  )}
                     </>
              )}
                  {/* Note Image - IMPORTANT: Using ShowimagesLoading */}
                  
                   {!n.tilte && (   <div 
                   className="note-image-wrapper"
                    style={{ position: "relative", overflow: "hidden", transition: "0.3s", width: "100%" }}
                   >
                      <ShowimagesLoading
                         src={n?.photoUrl || `${elakay_API}/products/readNoteGalerie/${n._id}/${i}`}
                        alt={nameImg || elakayAutoText("h_440a922a666c25", "Note image")}
                        className="note-image"
                        style={{ maxHeight: "400px", width: "100%", objectFit: "cover" }}
                      />
                        <div  
                        className="note-delete-btn"
                         style={{ float: "right", position: "absolute", top: "0", magirn: "0", padding: "0", backgroundColor: "rgba(255,255,255,0.1)", fontSize: "25px", color: "blue" }}
                         >
                          <MdDeleteForever onClick={() => deleteImageNote(token, productsID, n._id)} />
                          </div>
                    </div>
                   )}
             
            </div>
          ))}
        </div>
      )}
      
      {/* Empty State */}
      {(!note || note.length === 0) && (
        <div className="empty-state-notes">
          <p className="empty-state-text">
            {infoSource?.language(infoSource, "label", "noNotesYet") || elakayAutoText("h_779dcc5832df67", "No notes yet. Add your first note above.")}
          </p>
        </div>
      )}
    </div>
  </div>
);

// Product Bundles sits right above Compare Products (same tab strip order).
const BundlesSection = () => (
  <div className="content-card">
    <div className="card-content">
      <ProductBundleManager
        token={token}
        productId={productsID}
        ownerLabel={[infoSource?.userInfo?.firstname, infoSource?.userInfo?.lastname].filter(Boolean).join(" ") || infoSource?.userInfo?.email}
      />
    </div>
  </div>
);

const CompareSection = () => (
  <div className="content-card">
    <div className="card-header">
      <h3 className="card-title">
        {elakayAutoText("h_8d105cf44d3926", "Compare")}
      </h3>
    </div>
    <div className="card-content">
      <ProductCompareEditor
        token={token}
        productID={productsID}
        currentCompare={(getProduct?.ProdCompare || []).map((entry) => entry?._id).filter(Boolean)}
        requiresDropshippingPassword={isDropshippingSourced}
        onSaved={() => loadProductsView(productsID)}
      />
    </div>
  </div>
);

const SynchronizationSection = () => {
  const headerBadgeVariant = !syncStatusMeta
    ? "soon"
    : syncStatusMeta.autoSync === false
      ? "disabled"
      : syncStatusMeta.lastSyncStatus === "error"
        ? "error"
        : syncStatusMeta.lastSyncStatus === "success"
          ? "success"
          : "enabled";
  const headerBadgeLabel = !syncStatusMeta
    ? elakayAutoText("h_sync_header_loading", "Loading...")
    : syncStatusMeta.autoSync === false
      ? elakayAutoText("h_sync_badge_disabled", "Disabled")
      : syncStatusMeta.lastSyncStatus === "error"
        ? elakayAutoText("h_sync_badge_error", "Failed")
        : elakayAutoText("h_sync_badge_enabled", "Enabled");

  // Résolution (voir le useEffect près de getProduct) toujours en cours tant
  // que ni le résultat ni une erreur ne sont arrivés.
  const resolving = !syncResolveError && !syncStatusMeta;

  return (
    <div className="content-card">
      <div className="card-content">
        <div className="sync-header-card">
          <div className="sync-header-card__identity">
            <span className="sync-header-card__icon"><MdSync /></span>
            <div>
              <h3 className="sync-header-card__title">{elakayAutoText("h_sync_title", "Synchronization")}</h3>
              <p className="sync-header-card__desc">
                {elakayAutoText("h_sync_header_desc", "Keep this product in sync with its CJ Dropshipping source -- manually or automatically.")}
              </p>
            </div>
          </div>
          <div className="sync-header-card__meta">
            <SyncStatusBadge variant={headerBadgeVariant} label={headerBadgeLabel} />
            <span className="sync-header-card__lastsync">
              {elakayAutoText("h_cjsync_last_sync", "Last sync")}:{" "}
              <strong>{syncStatusMeta?.syncedAt ? new Date(syncStatusMeta.syncedAt).toLocaleString() : "-"}</strong>
            </span>
          </div>
        </div>

        {syncResolveError ? (
          <div className="sync-banner sync-banner--error">{syncResolveError}</div>
        ) : resolving ? (
          <div className="sync-skeleton-row" />
        ) : (
          <div className="sync-wizard-trigger">
            {/* Normalement injecté par DropshippingLayout.js, qui enveloppe
                toutes les routes internes du module CJ Dropshipping --
                editProduct.jsx ne monte jamais ce layout, donc sans ceci
                aucune règle cjwiz ou cjds n'atteint la page (tout le wizard
                s'affiche sans style). */}
            <style>{CJ_DROPSHIPPING_CSS}</style>
            <CJDropshippingProvider
              baseUrl={elakay_API}
              token={token}
              userId={infoSource?.userInfo?._id || ""}
              translate={elakayAutoText}
              roleName={getCurrentElakayRole(infoSource)}
            >
              <CJSyncModal
                inline
                mode="sync"
                dropshippingProductId={syncDropshippingProductId}
                elakayProductId={productsID}
                sellerAddress={infoSource?.address}
                onSynced={() => loadProductsView(productsID)}
              />
            </CJDropshippingProvider>
          </div>
        )}
      </div>
    </div>
  );
};


  const FiltersSection = () => {

  const PaymentAcceptanceSection = () => {
    if (!isProviderInternalSourced) return null;
    const rules = paymentAcceptanceLink?.providerProductId?.dropshippingPayment || {};
    return <section className="content-card dsia-payment-card" data-testid="edit-payment-acceptance">
      <div className="card-header"><h3 className="card-title">{elakayAutoText("h_ac9f15211ca281", "Payment acceptance")}</h3></div>
      <div className="card-content">
        {paymentAcceptanceLoading ? <p role="status">{elakayAutoText("h_payment_settings_loading", "Loading payment acceptance settings...")}</p> : !paymentAcceptanceLink ? <p role="alert">{paymentAcceptanceError}</p> : <PaymentAcceptanceChoice rules={rules} mode={paymentAcceptanceLink.acceptanceMode} needsConfirmation={paymentAcceptanceLink.paymentAcceptanceNeedsConfirmation} saving={paymentAcceptanceSaving} error={paymentAcceptanceError} onChange={savePaymentAcceptanceMode} />}
      </div>
    </section>;
  };

  // ========== SUB NAVIGATION (FOR FILTERS TAB) ==========
  const SubNavigationTabs = () => {
    if (activeTab !== "filters") return null;

    const subTabs = [
      // "Add Filter" + "Edit Filter" merged into one modern section, same
      // model as Provider Edit Product's "Filters & Images" (Filters from
      // your linked categories -> Filter combinations).
      { id: "combinations", label: elakayAutoText("h_seller_filters_combinations_tab", "Filters & Combinations") },
      // Ex-"Preview" : ce sous-onglet contient aussi la config d'affichage
      // (style Square/Circle/Images, images par valeur -- voir
      // DisplaySettings dans adfilterProduct.jsx), pas seulement un aperçu.
      // Renommé pour que les vendeurs le trouvent sans avoir à cliquer
      // dedans "au hasard".
      { id: "preview", label: elakayAutoText("h_adfilter_tab_display_settings", "Display Settings") },
      { id: "images", label: elakayAutoText("h_09e871c98fef3b", "Images") }
    ];

    return (
      <div className="sub-nav-tabs">
        {subTabs.map((tab) => (
          <button
            key={tab.id}
            className={`sub-nav-btn ${activeSubTab === tab.id ? "active" : ""}`}
            onClick={() => setActiveSubTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
    );
  };

    const renderFilterContent = () => {
      switch (activeSubTab) {
        case "combinations":
          return (
            <div className="filter-form provider-filters">
              <fieldset disabled={savingFilterCombinations} className="seller-filter-combinations-controls">
              {selFilterCatEnhanced()}

              <SellerFilterEditor editor={filterEditor} infoSource={infoSource} quantityLocked={isProviderInternalSourced} />
              {isProviderInternalSourced && <SellerProviderQuantityPanel productId={productsID} onChanged={() => loadProductsView(productsID)} />}
              </fieldset>
            </div>
          );


        case "preview":
          return (
            <div className="filter-preview">
              <h4 className="section-subtitle">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).editEditProduct.t012}</h4>
              <p className="section-hint">
                {elakayAutoText(
                  "h_adfilter_display_settings_hint",
                  "Select a filter below to choose how it appears to customers (square, circle, images, or a dropdown) and preview it live."
                )}
              </p>
              {isCJDropshippingProduct && (
                <CJVariantsSyncPanel
                  cjVariants={cjVariants}
                  syncedFilterProducts={syncedCJFilterProducts}
                  token={token}
                  productsID={productsID}
                  variantSwatchStyle={cjCompareData?.dropshippingData?.variantSwatchStyle || "square"}
                  onSynced={() => { loadProductsView(productsID); fetchCJCompareData(); }}
                />
              )}
                 <AddFilterProduct
                laguangeElakay={laguangeElakay}
                infoSource ={infoSource}
                ImagesProd={ImagesProd}
                filters={filtersCategory}
                filterSel={filterSel}
                catID={productsID}
                token={token}
                filtersProduct={filtersProduct}
                loadProductsView={loadProductsView}
                items={itemFilValue}
                />
            </div>
          );

        case "images":
          return ImagesGallerySection();

        default:
          return null;
      }
    };

    return (
      <div className="content-card">
        <PaymentAcceptanceSection />
        <div className="card-header">
          <h3 className="card-title">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).editEditProduct.t013}</h3>
        </div>
        <SubNavigationTabs />
        <div className="card-content">
          {renderFilterContent()}
        </div>
      </div>
    );
  };


  const AllImagePage = () => {
  // ========== PAGE 1: MORE IMAGES ==========
  if (pageLAAI === "moreImages") {
    return filtersProduct?.length > 0 ? (
      <div className="page-section-modern">
        <ImagesLoading
          laguangeElakay={laguangeElakay}
          infoSource={infoSource}
          filterID={FiltersHand.catID ? FiltersHand.catID : filtersProduct[0].catID}
          loadProductsView={loadProductsView}
          maxImgSize={NbrProdImgMax}
          ImagesProd={ImagesProd}
          imgSize={NrbProdImg}
          namProduct={name}
          FiltersHand={FiltersHand}
          productsID={productsID}
        />
      </div>
    ) : (
      <div className="alert-danger-modern">
        <h1 className="alert-title-modern">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).editEditProduct.t014}</h1>
        <h2 className="alert-subtitle-modern">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).editEditProduct.t015}</h2>
      </div>
    );
  }

  // ========== PAGE 2: LINK IMAGES ==========
  if (pageLAAI === "linkImages") {
    return (
      <div className="page-section-modern">
        <LinkImagesTofilterPro
          loadProductsView={loadProductsView}
          laguangeElakay={laguangeElakay}
          infoSource={infoSource}
          setImagesSMS={setImagesSMS}
          imagesSms={imagesSms}
          imagesArray={imagesArray}
          setImagesArray={setImagesArray}
          filtersProduct={filtersProduct}
          filterSel={filterSel}
          productID={productsID}
          prodGaleries={getProduct.galeries}
          token={token}
        />
      </div>
    );
  }

  // ========== PAGE 3: BACKGROUND IMAGES ==========
  if (pageLAAI === "pubImages") {
    return  <div className="page-section-modern">
       { allColor() }
      </div>
    
  }

  return null;
};


    // ========== IMAGES GALLERY SECTION ==========
    const ImagesGallerySection = () => {
      const refObjName = [
        "Index 0",
        "Follow Image",
        "Category Images",
        "Admin View",
        "Follow View",
        "Shop Slider"
      ];

      return (
        <div className="images-section">
          <div className="images-tabs">
            <button
              className={`image-tab-btn ${pageLAAI === "moreImages" ? "active" : ""}`}
              onClick={() => setPageLAAI("moreImages")}
            >
              <MdAdd />{__elakayText("t016", "Add More Images")}</button>
            <button
              className={`image-tab-btn ${pageLAAI === "linkImages" ? "active" : ""}`}
              onClick={() => setPageLAAI("linkImages")}
            >
              <MdImage />{__elakayText("t017", "Link to Filters")}</button>
            <button
              className={`image-tab-btn ${pageLAAI === "pubImages" ? "active" : ""}`}
              onClick={() => setPageLAAI("pubImages")}
            >
              <MdImage />{__elakayText("t018", "Publication Gallery")}</button>
          </div>
        {formImages(imagesArray)}
          <div className="images-content">
            {AllImagePage()}
          </div>
        </div>
      );
    };


        const prodViewEdit =()=>{
          return  <div className="row  mt-4 mb-4 justify-content-center" style={{backgroundColor: "WhiteSmoke"}}>
             <div className="col col-12 " style={{ textAlign: "center", backgroundColor: "Gainsboro" }}>
                        <h3>
                            {/* Product View */}
                            {infoSource.language(infoSource, "title", "prodView")}
                        </h3>
                    </div>
                <div className="col col-12">
                <ProdViewEdit
                 infoSource={infoSource}
                 laguangeElakay={laguangeElakay}
                 getProduct={getProduct}
                 getImages={getImages}
                />
                </div>

            </div>

        }
        const getAddressShop = (allAddress, addressShop)=>{
            const exists = allAddress.some(address => address.id === addressShop);
            if (exists) {
             return allAddress.filter(AS =>  AS._id === addressShop)[0].shopName
            } else {
              return allAddress[0]
        
            }
          }

          const bntInfoEditMissing = (key)=>{
            if(key == 'image'){
                   return <button 
                   onClick={() => {setPageLAAI("moreImages"); setEditInfoProd(false)}}
                   className="w-25 my-3 py-1 btn btn-outline-dark btn-md btn-block rounded-4"
                   >
                        {infoSource.laguangeElakay('Button', infoSource.languageAPI).submit}
                    </button>
            }
             if(key == 'category'){
                return <button 
                onClick={() => {setActiveTab("categories"); setEditInfoProd(false)}} 
                className="w-25 my-3 py-1 btn btn-outline-dark btn-md btn-block rounded-4"
                >
                        {infoSource.laguangeElakay('Button', infoSource.languageAPI).submit}
                    </button>
            }
            if(key == 'filter'){
                return <button 
                onClick={() => {setActiveSubTab("combinations"); setEditInfoProd(false)}}
                className="w-25 my-3 py-1 btn btn-outline-dark btn-md btn-block rounded-4"
                >
                        {infoSource.laguangeElakay('Button', infoSource.languageAPI).submit}
                    </button>
                
            }
          }
          
const PromoUsPr = ()=>{
    return <Modal show={editInfoProd} onHide={() => setEditInfoProd(false)} centered>
    <Modal.Body >
    <h3 className="text-danger">{editInfo.texte}</h3>
    <h6 className="text-danger">{editInfo.question}</h6>
    {bntInfoEditMissing(editInfo.key)}
    </Modal.Body>
</Modal>

}

const ProductStatusModalView = () => {
    return <Modal show={showProductStatusModal} onHide={() => setShowProductStatusModal(false)} centered size="lg" scrollable className="product-status-modal">
    <Modal.Header closeButton>
      <Modal.Title>{elakayAutoText("h_ps_title", "Product Status")}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <ProductStatusSwitch productId={productsID} token={token} product={getProduct} onChanged={() => loadProductsView(productsID)} />
    </Modal.Body>
  </Modal>
}  // ========== RENDER TAB CONTENT ==========
  const renderTabContent = () => {
    switch (activeTab) {
      case "info":
        return <>
        <button type="button" className="product-status-trigger" data-testid="product-status-trigger" onClick={() => setShowProductStatusModal(true)}>
          <span className="pst-label"><FaSlidersH aria-hidden="true" />{elakayAutoText("h_ps_title", "Product Status")}</span>
          <span className={`pst-badge${getProduct?.sellActive?.sell === true ? " pst-badge--active" : ""}`}>
            {getProduct?.sellActive?.sell === true && <FaCheck aria-hidden="true" />}
            {getProduct?.sellActive?.sell === true ? elakayAutoText("h_ps_active", "Active") : elakayAutoText("h_ps_inactive", "Inactive")}
          </span>
          <FaChevronRight className="pst-chevron" aria-hidden="true" />
        </button>
        <ProductEditPage
  graphicDesign={graphic}
  creatorDesign={creatorDesign}
  ImagesProd={ImagesProd}
  addImageToProduct={() => {
  setPageLAAI("moreImages");
  setEditInfoProd(false);
}}

 imagesArray={imagesArray}
 formImages={formImages}
 slots={slots}
  setSlots={setSlots}

infoSource={infoSource}
   name={name}
  description={description}
  price={price}
  costPrice={costPrice}
  words={words}
  inputValue={inputValue}
  shopIds={shopIds}
  setShopIds={setShopIds}
  addressSelect={addressSelect}
  address={address}
  values={values}
  graphic={graphic}
  filtersProduct={filtersProduct}
  getMaxkey={getMaxkey}
  handleChange={handleChange}
  handleKeyDown={handleKeyDown}
  setInputValue={setInputValue}
  setAddressSelect={setAddressSelect}
  setValues={setValues}
  deleteWord={deleteWord}
  addWord={addWord}
  clickSubmit={clickSubmit}
  checkGraphic={checkGraphic}
    productID = {productsID}
   authToken ={token}
  // ...autresPropsExistants
  SellerDashboardDemo={SellerDashboardDemo}
  ProductInfoForm={ProductInfoForm}
  SellerDashboard={SellerDashboard}
/>
        {/* Return / Replace settings: loaded from and saved to this product only
            (Dropshipping In: bounded by the Provider's rules, server-checked). */}
        <ReturnPolicyEditor productId={productsID} token={token} mode="seller" />
        </>;
      case "categories":
        return CategoriesSection();
      case "filters":
        return FiltersSection();
      case "notes":
        return NotesSection();
      case "bundles":
        return BundlesSection();
      case "compare":
        return CompareSection();
      case "sync":
        return SynchronizationSection();
      default:
        return null;
    }
  };
    return (
        <Layout
            title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).editEditProduct.t016}
            className="container-fluid"
            SliderPunShow={false}
            infoSource ={infoSource}
            {...infoSource?.allSettings?.layout}
               outOffPage={false}
            enableBodyParticles={false}
            enableFloatingSquares={false}
            enableContentFadeIn={false}
            enableFooterAnimations={false}
            enableSectionAnimations={false}
            enableItemAnimations={false}
            enableHoverAnimations={false}
            enableButtonAnimations={false}
            enableIconAnimations={false}
            enableBackgroundGrid={false}
            enableGradientOverlay={false}
            enableShineEffect={false}
            enableScrollAnimations={false}
            enableStaggeredAnimations={false}
            enableFloatingParticles={false}
            enableRippleEffect={false}
            enableTitleAnimations={false}
            enableLinkAnimations={false}
            enableDividerAnimations={false}
            enableCopyrightAnimations={false}
        >
           <div className="edit-product-container">
        <div className="edit-product-header">
          <h1 className="page-title">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).editEditProduct.t017}</h1>
          <p className="page-subtitle">{__elakayText("t019", "Manage your product information, categories, filters, and media")}</p>
        </div>
            <NavigationTabs />
             <div className="edit-product-content">
          {renderTabContent()}
        </div>
         
            {PromoUsPr()}
            {ProductStatusModalView()}
            {prodViewEdit()}
             <ProductGridEdit
                laguangeElakay={laguangeElakay}
                infoSource ={infoSource}
                 edit={true}
            />
            </div>
            </Layout>
    );

};

export default EditProduct;
